import React from "react";
import Api from "../../../../../../adapters/api/api";
import {
  Title,
  SubTitle,
  Wrapper,
  CommandButton,
  CommandDescription,
  CommandItem,
  CommandList,
} from "./style";
import { IServiceProviderProfile } from "../../../../../../interfaces/entities/IServiceProviderProfile";
import constants from "../../../../../../consts/conts";
import { useToast } from "../../../../../../hooks/Toast";

interface IExecuteCommand {
  command_name: string;
}

export const ProviderActions: React.FC<{
  profile: IServiceProviderProfile | null;
}> = ({ profile }) => {
  const { addToast } = useToast();

  if (!profile) {
    return null;
  }

  const getProfileName = () => {
    console.log("actions", profile);
    if (
      profile.id_service_provider_type_srcprf ===
      constants.service_provider_profile.pearson_type
    ) {
      return profile.provider_pearson?.name_prvprs;
    }
    return profile.provider_legal?.name_prvlgl;
  };

  const executeCommand = async (data: IExecuteCommand) => {
    try {
      const commandResponse = await Api.get(
        `/admin/provider/commands?command=${data.command_name}&profile_id=${profile.id_srcprf}`
      );
      addToast({
        title: "Atualização realizada",
        description: commandResponse.data.message,
        type: "success",
      });
    } catch (err: any) {
      const responseData = err.response?.data;

      if (err.response?.status === 422 && responseData?.data) {
        const message = Object.entries(responseData.data)
          .map(([field, error]) => `${field} - ${error}`)
          .join(", ");

        addToast({
          title: responseData.message || "Parâmetros inválidos",
          description: message,
          type: "error",
        });
      } else if (
        [401, 400].includes(err.response?.status) &&
        responseData?.message
      ) {
        addToast({
          title: "Erro ao executar comando",
          description: responseData.message,
          type: "error",
        });
      } else {
        addToast({
          title: "Erro ao executar comando",
          description:
            "Ocorreu um erro inesperado ao processar sua requisição. Tente novamente mais tarde.",
          type: "error",
        });
      }
    }
  };

  const runVerifyProfile = async () => {
    const confirmed = window.confirm(
      `Você realmente deseja verificar o perfil de ${getProfileName()}?`
    );
    if (!confirmed) return;
    await executeCommand({ command_name: "verify_profile" });
  };

  const runDeleteProfile = async () => {
    const confirmed = window.confirm(
      `Você realmente deseja excluir o perfil de ${getProfileName()}?`
    );
    if (!confirmed) return;
    await executeCommand({ command_name: "delete_profile" });
  };

  const runSyncPaymentStatus = async () => {
    const confirmed = window.confirm(
      `Tem certeza que deseja sincronizar o status de pagamento do perfil ${getProfileName()}?`
    );
    if (!confirmed) return;
    await executeCommand({ command_name: "sync_payment_status" });
  };

  return (
    <>
      <Title>Perfil</Title>
      <hr />
      <CommandList>
        <CommandItem>
          <CommandDescription>Verificar Perfil</CommandDescription>
          <CommandButton onClick={runVerifyProfile}>Executar</CommandButton>
        </CommandItem>
        <CommandItem>
          <CommandDescription>Excluir Perfil</CommandDescription>
          <CommandButton onClick={runDeleteProfile}>Executar</CommandButton>
        </CommandItem>
      </CommandList>

      <Title>integrações</Title>
      <hr />
      <Wrapper>
        <SubTitle>Fatura Agil</SubTitle>
        <CommandList>
          <CommandItem>
            <CommandDescription>
              Sincronizar pagamento (Fatura Agil)
            </CommandDescription>
            <CommandButton onClick={runSyncPaymentStatus}>
              Executar
            </CommandButton>
          </CommandItem>
        </CommandList>
      </Wrapper>
    </>
  );
};
